export const COLORS = {
    foundColor: '#3D4A68',
    notFoundColor: '#9C9C9C',
    areaColor: '#194ca7',
    infectedColor: '#CB0704',
    cleanColor: '#04cb04',
    suspiciousColor: '#FDB00D',
    sanitizedColor: '#7f00ff'
};
